import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Demo from "@/pages/Demo";
import PublicPresentation from "@/pages/PublicPresentation";
import Admin from "@/pages/Admin";
import Create from "@/pages/Create";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/demo" replace />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/p/:slug" element={<PublicPresentation />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/create" element={<Create />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
